export default __webpack_public_path__ + "static/media/settings.f038a0a7.svg";